import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const _LogoutRequestDtoSchema = z.object();
const LogoutResponseDtoSchema = z.string();

export type LogoutRequestDto = z.infer<typeof _LogoutRequestDtoSchema>;
export type LogoutResponseDto = z.infer<typeof LogoutResponseDtoSchema>;

export const logout = (config?: AxiosRequestConfig<LogoutRequestDto>) => {
  return api
    .post('/auth/logout', {}, config)
    .then(responseContract(LogoutResponseDtoSchema));
};
